// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
import { select2RemoteAjax } from './select2_remote';

(function() {

const MEMO_OCR_AUTO_POLISH_STORAGE_KEY = 'firmee_memo_ocr_auto_polish';

$(document).on("turbo:load", function() {

  if ($("#memo_user_id").is(':visible')) {
    $("#memo_user_id").select2({placeholder: "担当弁護士"});
  }

  if ($('#memo_contact_id').is(':visible')) {
    $('#memo_contact_id').select2(ajax_select);
  }

  // 事件選択時に関連弁護士プルダウンを更新
  if ($('#memo_matter_id').is(':visible')) {
    $('#memo_matter_id').select2(matter_select);
  }

  const setMemoOcrState = function(isLoading, message = '') {
    $('.memo-ocr-trigger').prop('disabled', isLoading);
    $('.memo-ocr-status').text(message);
  };

  const appendMemoOcrText = function(textarea, text) {
    const currentValue = textarea.val() || '';
    const cleanedText = $.trim(text || '');
    if (cleanedText.length === 0) { return; }

    let separator = '';
    if ($.trim(currentValue).length > 0) {
      separator = /\n\s*$/.test(currentValue) ? "\n" : "\n\n";
    }

    textarea.val(currentValue + separator + cleanedText);
    textarea.trigger('input').trigger('change');
  };

  const appendMemoOcrAttachment = function(file) {
    const storageInput = document.getElementById('memo-ocr-attachments');
    if ((storageInput == null) || (typeof DataTransfer === 'undefined')) { return false; }

    const existingFiles = Array.from(storageInput.files || []);
    const duplicate = existingFiles.some(existingFile => (existingFile.name === file.name) && (existingFile.size === file.size) && (existingFile.lastModified === file.lastModified));

    if (duplicate) { return true; }

    const dt = new DataTransfer();
    existingFiles.forEach(existingFile => dt.items.add(existingFile));
    dt.items.add(file);
    storageInput.files = dt.files;

    return true;
  };

  $('.memo-ocr-trigger').off('click').on('click', function() {
    const targetSelector = $(this).data('target-input');
    if (targetSelector != null) { $(targetSelector).trigger('click'); }
  });

  // 「OCR後に自動でAI清書する」チェックボックスの状態はlocalStorageに保存し、
  // 次回のメモ作成/編集フォームでも維持する。取得に失敗しても未チェック扱いにするだけでよい
  const memoOcrAutoPolishCheckbox = $('#memo-ocr-auto-polish');
  if (memoOcrAutoPolishCheckbox.length > 0) {
    try {
      memoOcrAutoPolishCheckbox.prop('checked', window.localStorage.getItem(MEMO_OCR_AUTO_POLISH_STORAGE_KEY) === 'true');
    } catch (e) {
      // localStorageが使えない環境(プライベートブラウズ等)ではデフォルトの未チェックのまま
    }

    memoOcrAutoPolishCheckbox.off('change').on('change', function() {
      try {
        window.localStorage.setItem(MEMO_OCR_AUTO_POLISH_STORAGE_KEY, this.checked ? 'true' : 'false');
      } catch (e) {
        // 保存できなくても今回の操作自体は継続する
      }
    });
  }

  $('.memo-ocr-input').off('change').on('change', function() {
    const file = this.files != null ? this.files[0] : undefined;
    const container = $('.memo-ocr-tools');
    const textarea = $(container.data('textarea-selector'));
    const ocrUrl = container.data('ocr-url');
    const missingUrlMessage = container.data('missing-url-message') || 'OCRの送信先URLが設定されていません。';
    const emptyMessage = container.data('empty-message') || '画像から文字を抽出できませんでした。';
    const successMessage = container.data('success-message') || '画像の文字を本文へ反映しました。';

    if (file == null) { return; }

    if ((ocrUrl == null) || (ocrUrl.length === 0)) {
      alert(missingUrlMessage);
      this.value = '';
      return;
    }

    const formData = new FormData();
    formData.append('image', file);

    setMemoOcrState(true, `OCR中: ${file.name}`);
    // 前回のAI清書の結果メッセージが残っていると、新しいOCRの進行中に紛らわしいので消しておく
    $('.memo-ai-status').text('');

    $.ajax({
      url: ocrUrl,
      type: 'POST',
      data: formData,
      dataType: 'json',
      processData: false,
      contentType: false,
      timeout: 60000
    }).done(function(data) {
      if ((data != null ? data.content : undefined) != null) {
        appendMemoOcrText(textarea, data.content);
        appendMemoOcrAttachment(file);
        setMemoOcrState(false, successMessage);

        // 「OCR後に自動でAI清書する」がオンなら、続けて清書処理まで自動実行する。
        // 清書の進捗・結果は.memo-ai-statusに表示されるため、こちらのOCR成功メッセージは残したままにする
        if ($('#memo-ocr-auto-polish').is(':checked')) {
          performMemoAiModify();
        }
      } else {
        setMemoOcrState(false, '');
        alert(emptyMessage);
      }
    }).fail(function(xhr) {
      setMemoOcrState(false, '');
      const message = (xhr.responseJSON != null ? xhr.responseJSON.error : undefined) || '画像の読み取りに失敗しました。';
      alert(message);
    }).always(() => {
      this.value = '';
    });
  });

  const setMemoAiState = function(isLoading, message = '') {
    $('#ai-modify').prop('disabled', isLoading);
    $('.memo-ai-status').text(message);
  };

  let memoAiPreviousContent = null;
  let memoAiFilledTitle = false;

  const clearMemoAiSchedules = function() {
    const panel = $('.memo-ai-schedules');
    panel.find('.memo-ai-schedules-list').empty();
    panel.hide();
  };

  // AIが抽出した予定ごとに、プリフィル済みの予定作成フォームへのリンクを描画する
  const renderMemoAiSchedules = function(schedules) {
    const panel = $('.memo-ai-schedules');
    if (panel.length === 0) { return; }

    const list = panel.find('.memo-ai-schedules-list');
    list.empty();

    if (!$.isArray(schedules) || (schedules.length === 0)) {
      panel.hide();
      return;
    }

    const baseUrl = panel.data('schedule-new-url') || '/schedules/new';
    const createLabel = panel.data('create-label') || '';
    const sourceLabel = panel.data('source-label') || '';
    const placeLabel = panel.data('place-label') || '';
    const noTimeLabel = panel.data('no-time-label') || '';
    const matterId = $(panel.data('matter-selector') || '#memo_matter_id').val();

    $.each(schedules, function(_index, schedule) {
      if (schedule == null) { return; }

      const query = { type: schedule.schedule_type || 'Trial' };
      if (schedule.name) { query.name = schedule.name; }
      if (schedule.start_at) { query.start = schedule.start_at; }
      if (schedule.courtroom) { query.courtroom = schedule.courtroom; }
      if (matterId) { query.matter_id = matterId; }

      const item = $('<li class="list-group-item"></li>');

      const heading = $('<div></div>');
      heading.append($('<strong></strong>').text(schedule.name || ''));
      let startText = schedule.start_at || '';
      if (startText && !schedule.has_time && noTimeLabel) {
        startText = `${startText} (${noTimeLabel})`;
      }
      if (startText) {
        heading.append($('<span style="margin-left: 8px;"></span>').text(startText));
      }
      item.append(heading);

      if (schedule.courtroom) {
        item.append($('<div class="help-block" style="margin: 2px 0 0;"></div>')
          .text(`${placeLabel}: ${schedule.courtroom}`));
      }
      if (schedule.source_text) {
        item.append($('<div class="help-block" style="margin: 2px 0 0;"></div>')
          .text(`${sourceLabel}: ${schedule.source_text}`));
      }

      const link = $('<a class="btn btn-default btn-xs" target="_blank" rel="noopener"></a>')
        .attr('href', `${baseUrl}?${$.param(query)}`)
        .text(createLabel);
      item.append($('<div style="margin-top: 4px;"></div>').append(link));

      list.append(item);
    });

    panel.show();
  };

  $('#ai-modify-undo').off('click').on('click', function(ev) {
    ev.preventDefault();
    if (memoAiPreviousContent === null) { return; }

    const container = $('.memo-ai-tools');
    const textarea = $(container.data('textarea-selector'));

    textarea.val(memoAiPreviousContent).trigger('input').trigger('change');
    memoAiPreviousContent = null;

    if (memoAiFilledTitle) {
      $('#memo_title').val('').trigger('change');
      memoAiFilledTitle = false;
    }

    clearMemoAiSchedules();
    $(this).hide();
    $('.memo-ai-status').text('');
  });

  // 清書リクエストに載せるフォームの文脈(メモ日付・事件・連絡先・種別)。
  // 要素が無い / 未選択のときはキーごと送らない(サーバ側は文脈なしで清書する)
  const memoAiContextParams = function(container, content) {
    const params = { content: content };
    const fields = {
      memo_date: container.data('date-selector') || '#memo_time_at',
      matter_id: container.data('matter-selector') || '#memo_matter_id',
      contact_id: container.data('contact-selector') || '#memo_contact_id',
      memo_type: container.data('memo-type-selector') || '#memo_memo_type'
    };

    $.each(fields, function(key, selector) {
      const element = $(selector);
      if (element.length === 0) { return; }

      const value = element.val();
      if ((value == null) || ($.trim(String(value)).length === 0)) { return; }

      params[key] = value;
    });

    return params;
  };

  // AIによる清書の実処理。#ai-modifyのクリックからも、OCR後の自動清書からも呼ばれる共通関数。
  // 呼ばれた時点のtextareaの内容をmemoAiPreviousContentとして保持するため、
  // OCR直後に呼ばれた場合は「元に戻す」でOCR結果が入った状態(清書前)に戻る
  const performMemoAiModify = function() {
    const container = $('.memo-ai-tools');
    const textarea = $(container.data('textarea-selector'));
    const actionUrl = container.data('action-url');
    const processingMessage = container.data('processing-message') || '';
    const successMessage = container.data('success-message') || '';
    const connectionErrorMessage = container.data('connection-error-message') || '';

    const content = textarea.val();
    if ($.trim(content || '').length === 0) { return; }

    const previousContent = content;

    setMemoAiState(true, processingMessage);
    $('#ai-modify-undo').hide();
    clearMemoAiSchedules();

    return $.ajax({
      url: actionUrl,
      type: 'POST',
      dataType: 'json',
      data: memoAiContextParams(container, content),
      timeout: 60000
    }).done(function(data) {
      textarea.val(data.content).trigger('input').trigger('change');
      memoAiPreviousContent = previousContent;

      // 件名は未入力のときだけ補完し、入力済みの内容は上書きしない
      const titleInput = $($('.memo-ai-schedules').data('title-selector') || '#memo_title');
      memoAiFilledTitle = false;
      if (data.title_suggestion && ($.trim(titleInput.val() || '').length === 0)) {
        titleInput.val(data.title_suggestion).trigger('change');
        memoAiFilledTitle = true;
      }

      renderMemoAiSchedules(data.schedules);

      $('#ai-modify-undo').show();
      setMemoAiState(false, successMessage);
    }).fail(function(xhr) {
      const message = (xhr.responseJSON != null ? xhr.responseJSON.error : undefined) || connectionErrorMessage;
      setMemoAiState(false, '');
      alert(message);
    });
  };

  $('#ai-modify').off('click').on('click', function(ev) {
    ev.preventDefault();
    performMemoAiModify();
  });

  $('#phone-toggle').off('click').on('click', function(ev) {
    ev.preventDefault();
    $('#phone-info').toggle(500);
    $("span", this).toggleClass("fa-minus-square");
    $("span", this).toggleClass("fa-plus-square");
  });
});

const select2_is_ja = (document.documentElement.lang || 'ja').startsWith('ja');
const ajax_select = {
  language: select2_is_ja ? "ja" : "en",
  allowClear: true,
  placeholder: select2_is_ja ? "漢字名で検索" : "Search by name",
  ajax: select2RemoteAjax({
    url: "/contacts.json",
    query: params => ({ search_text_cont_all: params.term })
  }),
  escapeMarkup(markup) { return markup; }, // let our custom formatter work
  minimumInputLength: 1
};

const matter_select = {
  language: select2_is_ja ? "ja" : "en",
  allowClear: true,
  placeholder: select2_is_ja ? "事件検索" : "Search matters",
  ajax: select2RemoteAjax({
    url: "/matters.json",
    query: params => ({
      search_text_cont_all: params.term,
      include_non_related: true,
      include_completed: true
    })
  }),
  escapeMarkup(markup) { return markup; }, // let our custom formatter work
  minimumInputLength: 1
};

})();
